
import { apiFetch } from "./client";

export const fetchTerms = () => apiFetch("/outreach/api/legal/terms/");

export const fetchPrivacy = () => apiFetch("/outreach/api/legal/privacy/");
